import React, {useContext, useState} from 'react';
import messageicon from "../../assets/images/messageicon.svg";
import {Button, Table} from "reactstrap";
import {IoIosCopy} from "react-icons/io";
import {GrPowerReset} from "react-icons/gr";
import authContext from "../../AuthProvider/authContext";
import {handleError, showsuccesToast} from "../HandleError";
import localized from "../../i18n";
import axios from "axios";
import {Link} from "react-router-dom";

const Apitable = () => {
    const [isResetting,setIsResetting] = useState(false);
    const {state,getAuthenticatedUser} = useContext(authContext);
    const {auth} = state;

    const toggleResetButton = (response = false) => {
        setIsResetting(response);
    }
    const copyToClipboard = () => {
        const cb = navigator.clipboard;
        const paragraph = auth.api_key ? auth.api_key : "";
        cb.writeText(paragraph).then(() => {
            showsuccesToast(localized.api_key_copied_successfully);
        });
    };

    const resetAPIKey = () => {
        toggleResetButton(true);
        return axios.get('/api/reset-api-key')
            .then(()=> {
                showsuccesToast("API key Reset Successfully.")
                getAuthenticatedUser();
                toggleResetButton(false);
            }).catch((err)=>{
                handleError(err);
                toggleResetButton(false);
            })
    }

    return (
        <div className="DashboardTable-main api-documentation">
            <div className="DashboardTable-heading">
                <div><img src={messageicon} alt=""/></div>
                <h2 className="mb-0">{auth.api_key === null ?localized.api_access_is_reserved_to_paid_users :localized.api_Documentation}</h2>
            </div>
            <div className="DashboardTable-container justify-content-between d-flex flex-wrap p-4">
                {auth.api_key && (
                    <div className="generate_api_key flex-wrap">
                        <span className="label text-nowrap"> {localized.api_key}</span>
                        <div className="flex-column d-flex align-items-start">
                            <span className="api_key" >{auth.api_key}</span>
                        </div>

                        <div className="actions">
                            <Button className="user-select-none btn-secondary copy-btn" onClick={copyToClipboard}><IoIosCopy/>{localized.copy}</Button>
                            <span onClick={resetAPIKey}>
                            {isResetting ? localized.resetting :  (
                                <> <GrPowerReset className="resetIcon"/> {localized.reset} </>
                            )}
                        </span>
                        </div>
                    </div>
                )}
                <div className="Read_Documentation">
                    <a href='https://verif.email/api-doc/' target="_blank">{localized.read_documentation}</a>
                </div>
            </div>
        </div>
    );
};

export default Apitable;